import moment, { Moment } from 'moment';
// 定义接口
export interface DateShortcutType {
  name: string;
  nameCN: string;
  onClick: () => Array<Moment | null>;
}

export interface ShortcutOptionType {
  [type: string]: DateShortcutType[];
}

export const RANTE_TYPE = ['date', 'week', 'month'];
/** 时间筛选器，可单日单周单月也可日周月 */
export const RANGE_TIME = 'rangeTime';
export const RANGE_RELEASE_TIME = 'rangeReleaseTime';
/** 日期筛选器 */
export const DATE_PICKER = 'datePicker';
/** Following新游的时间筛选器 */
export const DAY_RANGE_TIME = 'newGame_rangeTime';
/** Release时间筛选器 */
export const RELEASE_TIME = 'releaseTime';
/** 品类筛选器 */
export const GENRETOR = 'genretor';
/** 带数据源切换Segment的品类筛选器 */
export const GENRETOR_WITH_SEGMENT = 'genretorWithSegment';
/** 国家筛选器 */
export const REGION = 'region';
/** 筛选器换行字段 */
export const ROW = 'row';
/** 筛选器同行左对齐 */
export const LEFT = 'left';
/** 筛选器同行左对齐 */
export const RIGHT = 'right';
/** 数据源说明字段 */
export const SUMMARY_CARD = 'summaryCard';
/** 数据源说明控制按钮字段 */
export const SOURCE_EXPLANATION = 'sourceExplanation';
/** 数据源HTML解释说明触发器容器字段 */
export const DATA_SOURCE_EXPLANATION_TRIGGER = 'dataSourceExplanationTrigger';
/** 数据源HTML解释说明内容容器字段 */
export const DATA_SOURCE_EXPLANATION_BODY = 'dataSourceExplanationBody';
/** KPI Trends 舆情事件标注设置 */
export const OPINION_EVENT_SETTING = 'opinion_event_setting';
/** 自定义布局打开保存筛选器按钮字段 */
export const SAVE_FILTER_SETTINGS = 'saveFilterSettings';
/** 自定义布局重置按钮字段 */
export const RESET = 'reset';
export const KPITRENDS_REASE = 'KPITrends_reset';
// Calibration Metrics Switch按钮组件key
export const KPITRENDS_CALIBRATION_METRICS_SWITCHER = 'KPITrends_calibration_metrics_switcher';
/** ALL Company */
export const ALL_COMPANYS = 'allComapys';
export const ALL_Games = 'allGames';
export const DATASOURCE = 'dataSource';
export const DATASOURCESIM = 'dataSourceSingle';
export const PUBLISHER = 'publisher';
export const PUBLISHER_COMPANY = 'publisher_company';
export const PUBLISHER_CLASS = 'publisher_class';
export const PUBLISHER_REGION = 'publisher_region';
export const DEVELOPER = 'developer';
/** HotTagsSource 数据来源筛选器 */
export const HOT_TAGS_SOURCE = 'hotTagsSource';
export const REVENUE_SCOPE = 'revenue_scope';
export const PLATFORM = 'platForm';
export const STREAMING_PLATFORM = 'streaming_platForm';
export const PHEAD_RANG = 'pheatRang';
export const MY_FILTER = 'myFilter';
export const PLAN = 'plan';
export const RETENTION = 'retention';
export const GAME_TYPE = 'gameType';
export const IPO_STATUS = 'ipoStatus';
export const COUNTRY = 'country';
export const CONSOLE_DEVICE = 'console_device';
export const DIGITAL_DEVICE = 'digital_device';
export const LIFETIME_DEVICE = 'lifetime_device';
export const MAU_DEVICE = 'mau_device';
export const PHYSICAL_DEVICE = 'physical_device';
export const JAPANSALES_DEVICE = 'japansales_device';
export const METRICTABLE_DEVICE = 'metrictable_device';
export const GSD_DEVICE = 'gsd_device';
export const COMPETITOR_PLATFORM = 'competitor_platform';
export const PCCONSOLE_TOPCHARTS_METRICS = 'pcConsole_topCharts_metrics';

export const DIGITAL_SEGEMENT = 'digital_segement';
export const DIGITAL_SEGMENT_MULTIPLE = 'digital_segment_multiple';
export const ENGAGELEVEL_SEGEMENT = 'engageLevel_segement';
export const REGION_SEGMENT = 'region_segement';
export const REGION_COUNTRY_SELECTOR = 'region_country_selector';
export const ENGAGELEVEL_SEGEMENT_TWO = 'engageLevel_segement_two';
export const ENGAGELEVEL_SEGEMENT_B = 'engageLevel_segement_b';
export const STORERANK_SEGEMENT = 'storerank_segement';
export const OVERLAPSTEAM_PLAYERS = 'overlapSteam_players';
export const GSD_SEGEMENT = 'gsd_segement';
export const COMPOSED_SELECT = 'composed_select';
export const SINGLE_AREA_SELECT = 'single_area_select';
export const MULTIPLE_AREA_SELECT = 'multiple_area_select';
export const COMPOSED_COUNTRY_SELECT = 'composed_country_select';
export const REGION_CASCADER_SELECT = 'region_cascader_select';
export const SINGLE_PLATFORM_SELECT = 'single_platform_select';
export const SINGLE_SOURCE_SELECT = 'single_source_select';
export const MULTIPLE_SOURCE_SELECT = 'multiple_source_select';
export const KOL_PLATFORM = 'kol_platform';
export const KOL_LANGUAGE = 'kol_language';
export const KOL_COUNTRIES = 'kol_countries';
export const FOLLOWING_GLOUP = 'following-gloup';
export const APP_SELECTOR = 'app_selector';
export const HEAT_MAP = 'heatMap';
export const SHOW_TOP_COUNTRIES = 'showTopCountries';
export const ICONABLE_CHECKBOX_SELECT = 'sourceCheckbox';

export const DATA_SOURCE_FULL = 'data_source_full';
export const GAMETYPE_FULL = 'gametype_full';
export const SERVICE_TYPE_FULL = 'service_type_full';
export const CHANNEL_TYPE_FULL = 'channel_type_full';
export const OPINION_SOURCEDATA_FULL = 'opinion_data_source_full';
export const METRICS_SOURCEDATA_FULL = 'metrics_data_source_full';
export const METRICS_FULL = 'metrics_full';
export const QRANULARITY_FULL = 'granularity_full';
export const FREQ_FULL = 'frequency_full';
export const REVENUE_GROWTH = 'revenueGrowth';
export const REVENUE_GROWTH_TWO = 'revenueGrowthTwo';
export const REVENUE_RANGE = 'revenueRange';
export const ARPU_RANGE = 'arpuRange';
export const ACTIVE_USERS_RANGE = 'activeUsersRange';
export const DOWNLOADS_RANGE = 'downloadsRange';
export const RPD_RANGE = 'rpdRange';
export const D2_RANGE = 'd2Range';
export const D3_RANGE = 'd3Range';
export const D7_RANGE = 'd7Range';
export const D15_RANGE = 'd15Range';
export const D31_RANGE = 'd31Range';

/** Retention 页 D2–D31 区间筛选器配置 */
export const RETENTION_D_RANGE_DEFS = [
  {
    key: D2_RANGE,
    titleKey: 'dbi_d2_range',
    metric: 'sensortower__d2',
    hoverKey: 'dbi_info_mobile_filter_d2_range_hover',
    labelZh: 'D2区间',
    labelEn: 'D2 Range',
  },
  {
    key: D3_RANGE,
    titleKey: 'dbi_d3_range',
    metric: 'sensortower__d3',
    hoverKey: 'dbi_info_mobile_filter_d3_range_hover',
    labelZh: 'D3区间',
    labelEn: 'D3 Range',
  },
  {
    key: D7_RANGE,
    titleKey: 'dbi_d7_range',
    metric: 'sensortower__d7',
    hoverKey: 'dbi_info_mobile_filter_d7_range_hover',
    labelZh: 'D7区间',
    labelEn: 'D7 Range',
  },
  {
    key: D15_RANGE,
    titleKey: 'dbi_d15_range',
    metric: 'sensortower__d15',
    hoverKey: 'dbi_info_mobile_filter_d15_range_hover',
    labelZh: 'D15区间',
    labelEn: 'D15 Range',
  },
  {
    key: D31_RANGE,
    titleKey: 'dbi_d31_range',
    metric: 'sensortower__d31',
    hoverKey: 'dbi_info_mobile_filter_d31_range_hover',
    labelZh: 'D31区间',
    labelEn: 'D31 Range',
  },
] as const;

export const RETENTION_D_RANGE_KEYS = RETENTION_D_RANGE_DEFS.map(item => item.key);

export const RETENTION_D_RANGE_TITLE_MAP: IRecord<string> = RETENTION_D_RANGE_DEFS.reduce(
  (acc, item) => {
    acc[item.key] = item.titleKey;
    return acc;
  },
  {} as IRecord<string>,
);

export const RETENTION_D_RANGE_HOVER_MAP: IRecord<string> = RETENTION_D_RANGE_DEFS.reduce(
  (acc, item) => {
    acc[item.key] = item.hoverKey;
    return acc;
  },
  {} as IRecord<string>,
);

export const MOBILE_OVERLAP = 'mobileOverlap';
export const REVENUE_RANGE_UNIT = 'revenue_range_unit';
export const PCU_RANGE = 'pcu_range';
export const WISHLISTS_RANGE = 'wishlists_range';
export const DIGITAL_RANGE = 'digital_range';
export const PHYSICAL_RANGE = 'physical_range';
export const PRICE_RANGE = 'price_range';
export const PREMIUM_RANGE = 'premium_range';
export const TIPICON = 'TIPICON';
export const STREAMING_GAME_TYPE = 'STREAMING_GAME_TYPE';
export const METRIC_SELECT_FOR_KPI_TREND = 'metric_selection_for_trends';
export const METRIC_SELECT_FOR_KPI_TREND_PLATFORM_TOGGLE = 'metric_selection_for_trends_platform_toggle';
export const ALIGN_TO_RELEASE = 'align_to_release';
export const STEAM_TAGS = 'steam_tag';
export const GAME_MODE = 'game_mode';
export const GAME_ENGINE = 'game_engine';
export const DOWNLOAD = 'download';

/** 筛选器分组配置 */
export interface IFilterGroup {
  /** 分组唯一 key */
  key: string;
  /** 分组标题国际化 key */
  titleKey?: string;
  /** 无国际化时的标题兜底 */
  title?: string;
  /** 数据源 icon code，传给 getDataSourceIcon */
  iconCode?: string;
  /** 该分组包含的真实筛选器 key，顺序即视觉顺序 */
  filterKeys: string[];
  /** 额外样式类名 */
  className?: string;
}

export interface IGroupedFilterList {
  /** 真实筛选器 key 列表 */
  filterKeyList: string[];
  /** 分组布局配置 */
  filterGroups: IFilterGroup[];
}

/** 从分组配置生成 FilterBase 需要的 flat key list */
export const defineFilterGroups = (
  filterGroups: IFilterGroup[],
  options?: { ungroupedKeys?: string[]; },
): IGroupedFilterList => ({
  filterGroups,
  filterKeyList: filterGroups.reduce<string[]>((keys, group) => {
    keys.push(...group.filterKeys);
    return keys;
  }, [...(options?.ungroupedKeys || [])]),
});

// Sub-keys for differentiating MetricsSelection components
export const METRIC_SUBKEY_SHORTCUT = 'shortcut_selection';
export const METRIC_SUBKEY_METRIC_TYPE = 'metric_type_selection';
export const METRIC_SUBKEY_SHOT = 'shot_selection';
export const METRIC_SUBKEY_SHOT_METRIC = 'metric_type';
export const METRIC_SUBKEY_SHOT_DATA_SOURCE = 'data_source';
export const METRIC_SUBKEY_METRICS = 'metrics_selection';
// Art Style筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_ART_STYLE = 'sensor_tower_tag_art_style';
// Camera Pov筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_CAMERA_POV = 'sensor_tower_tag_camera_pov';
// Product Model筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_PRODUCT_MODEL = 'sensor_tower_tag_product_model';
// Setting筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_SETTING = 'sensor_tower_tag_setting';
// Tags筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_TAGS = 'sensor_tower_tag_tags';
// Theme筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_THEME = 'sensor_tower_tag_theme';
// Monetization筛选器（Mobile游戏的Sensor Tower Tag的筛选器）
export const SENSOR_TOWER_TAG_MONETIZATION = 'sensor_tower_tag_monetization';
export const CASCADER = 'cascader';
export const PLATFORMCASCADER = 'platform_cascader';
// 所有Sensor Tower Tag的筛选器key集合
export const SENSOR_TOWER_TAG_KEYS = [
  SENSOR_TOWER_TAG_ART_STYLE,
  SENSOR_TOWER_TAG_CAMERA_POV,
  SENSOR_TOWER_TAG_PRODUCT_MODEL,
  SENSOR_TOWER_TAG_SETTING,
  SENSOR_TOWER_TAG_TAGS,
  SENSOR_TOWER_TAG_THEME,
  SENSOR_TOWER_TAG_MONETIZATION,
];
export const SENSOR_TOWER_TAG_TITLE_MAP = {
  [SENSOR_TOWER_TAG_ART_STYLE]: 'dbi_detail_art_style',
  [SENSOR_TOWER_TAG_CAMERA_POV]: 'dbi_detail_camera_pov',
  [SENSOR_TOWER_TAG_PRODUCT_MODEL]: 'dbi_detail_product_model',
  [SENSOR_TOWER_TAG_SETTING]: 'dbi_detail_setting',
  [SENSOR_TOWER_TAG_TAGS]: 'dbi_detail_tags',
  [SENSOR_TOWER_TAG_THEME]: 'dbi_detail_theme',
  [SENSOR_TOWER_TAG_MONETIZATION]: 'dbi_detail_monetization',
};
export const SENSOR_TOWER_TAG_MAP: IRecord<string> = {
  [SENSOR_TOWER_TAG_ART_STYLE]: 'Art Style',
  [SENSOR_TOWER_TAG_CAMERA_POV]: 'Camera POV',
  [SENSOR_TOWER_TAG_PRODUCT_MODEL]: 'Product Model',
  [SENSOR_TOWER_TAG_SETTING]: 'Setting',
  [SENSOR_TOWER_TAG_TAGS]: 'Tag',
  [SENSOR_TOWER_TAG_THEME]: 'Theme',
  [SENSOR_TOWER_TAG_MONETIZATION]: 'Monetization',
};

// Themes筛选器（Mobile游戏的App Magic Tag的筛选器）
export const APPMAGIC_TAG_THEMES = 'appmagic_themes';
// Features筛选器（Mobile游戏的App Magic Tag的筛选器）
export const APPMAGIC_TAG_FEATURES = 'appmagic_features';
// IP筛选器（Mobile游戏的App Magic Tag的筛选器）
export const APPMAGIC_TAG_IP = 'appmagic_ip';
// Settings筛选器（Mobile游戏的App Magic Tag的筛选器）
export const APPMAGIC_TAG_SETTINGS = 'appmagic_settings';
// Art Styles筛选器（Mobile游戏的App Magic Tag的筛选器）
export const APPMAGIC_TAG_ART_STYLES = 'appmagic_art_styles';
// 所有App Magic Tag的筛选器key集合
export const APPMAGIC_TAG_KEYS = [
  APPMAGIC_TAG_THEMES,
  APPMAGIC_TAG_FEATURES,
  APPMAGIC_TAG_IP,
  APPMAGIC_TAG_SETTINGS,
  APPMAGIC_TAG_ART_STYLES,
];
// 所有App Magic Tag的筛选器名称翻译key映射
export const APPMAGIC_TAG_TITLE_MAP: IRecord<string> = {
  [APPMAGIC_TAG_THEMES]: 'dbi_appmagic_themes',
  [APPMAGIC_TAG_FEATURES]: 'dbi_appmagic_features',
  [APPMAGIC_TAG_IP]: 'dbi_appmagic_ip',
  [APPMAGIC_TAG_SETTINGS]: 'dbi_appmagic_settings',
  [APPMAGIC_TAG_ART_STYLES]: 'dbi_appmagic_art_styles',
};
// 所有App Magic Tag的筛选器接口字段映射
export const APPMAGIC_TAG_MAP: IRecord<string> = {
  [APPMAGIC_TAG_THEMES]: 'themes',
  [APPMAGIC_TAG_FEATURES]: 'features',
  [APPMAGIC_TAG_IP]: 'ip',
  [APPMAGIC_TAG_SETTINGS]: 'settings',
  [APPMAGIC_TAG_ART_STYLES]: 'art_styles',
};
// 所有App Magic Tag的筛选器默认value映射
export const APPMAGIC_TAG_DEFAULT_VALUES: IRecord<{ value: string[] }> = APPMAGIC_TAG_KEYS.reduce((values, key) => {
  const value = { value: [] };
  return { ...values, [key]: value };
}, {});

/** 批量为筛选器 key 赋相同配置值 */
export const assignFilterKeys = <T>(keys: readonly string[], value: T): Record<string, T> =>
  keys.reduce((acc, key) => {
    acc[key] = value;
    return acc;
  }, {} as Record<string, T>);

export const EMPTY_NUMBER_RANGE_VALUE = { value: { min: '', max: '' } };

export const buildEmptyNumberRangeDefaults = (keys: readonly string[]) =>
  assignFilterKeys(keys, EMPTY_NUMBER_RANGE_VALUE);

/** metric range 筛选器 → handleMetricRangeFilter 所需 source map */
export const buildMetricRangeSourceMap = (
  defs: readonly { key: string; metric: string }[],
) =>
  defs.reduce((acc, item) => {
    acc[item.key] = { type: 'range', source: item.key, metric: item.metric };
    return acc;
  }, {} as Record<string, { type: string; source: string; metric: string }>);

/** NumberRange 筛选器 CommonFilter inputList 配置 */
export const buildNumberRangeInputListItems = (
  defs: readonly { key: string; titleKey: string; labelZh: string; labelEn: string }[],
  defaultValue: Record<string, any>,
  locale: string,
) =>
  defs.reduce((acc, item) => {
    acc[item.key] = {
      savePopupVisble: 1,
      title: item.titleKey,
      titleDefaultMessage: locale === 'zh-CN' ? item.labelZh : item.labelEn,
      type: item.key,
      key: item.key,
      leftPlaceholder: 'dbi_minimum',
      rightPlaceholder: 'dbi_maximum',
      unitText: '%',
      decimalPlaces: 2,
      default: defaultValue[item.key],
    };
    return acc;
  }, {} as Record<string, any>);

/** AppMagic 标签筛选器 specialParams 配置 */
export const buildAppMagicTagSpecialParams = (
  filterTags: IRecord<any[]> | null | undefined,
  isCn: boolean,
): IRecord<any> => {
  if (!filterTags) return {};

  const mapTagData = (tags: any[]) => {
    if (!Array.isArray(tags) || tags.length === 0) return [];
    return tags.map((tag) => {
      const tagValue = tag?.tag || '';
      const tagEN = tag?.tag_en || '';
      const tagCN = tag?.tag_cn || '';
      const tagDefault = tagValue || tagEN || tagCN;
      return {
        value: tagDefault,
        text: (isCn ? tagCN : tagEN) || tagDefault,
        textCN: tagCN || tagDefault,
        textEN: tagEN || tagDefault,
      };
    });
  };

  return APPMAGIC_TAG_KEYS.reduce((config, key) => {
    const apiFieldName = APPMAGIC_TAG_MAP[key];
    config[key] = {
      options: mapTagData(filterTags[apiFieldName]),
      title: APPMAGIC_TAG_TITLE_MAP[key],
    };
    return config;
  }, {} as IRecord<any>);
};

/** 筛选器继承类型 */
export const RANGE_TIME_EXTEND_TYPE = {
  singleMonth: 'singleMonth',
  singleDate: 'singleDate',
  onlyDate: 'date',
};
export const RANGE_TIME_EXTEND_TYPE_VALUE = {
  Date: 'date',
};
export const REGION_EXTEND_TYPE = {
  common: 'common',
  retention: 'retention',
  rpd: 'rpd',
  newgames: 'newrelease_upcoming',
  metricTable: 'metricTable',
  digitalRevenue: 'digitalRevenue',
  mau: 'mau',
  lifetimePlayers: 'lifetimePlayers',
};
export const DEVICE_EXTEND_TYPE = {
  digitalRevenue: 'digitalRevenue',
  physicalRevenue: 'physicalRevenue',
};

// 默认upcoming榜单start_release_time时间
export const START_RELEASE_TIME = moment().add(1, 'days').format('YYYY-MM-DD');

// 默认upcoming榜单end_release_time时间
export const END_RELEASE_TIME = moment().add(6, 'M').format('YYYY-MM-DD');

/** 时间类型筛选器，日周月 */
export const TIME_TYPE = 'timeType';

export const TIME_TYPE_EXTEND_TYPE = {
  common: 'common',
};

export const COMPOSED_COUNTRY_SELECT_EXTEND_TYPE = {
  common: 'common',
};

export const SINGLE_PLATFORM_SELECT_EXTEND_TYPE = {
  common: 'common',
};

export const SINGLE_SOURCE_SELECT_EXTEND_TYPE = {
  common: 'common',
};

export const SINGLE_AREA_SELECT_EXTEND_TYPE = {
  common: 'common',
};

export const MULTIPLE_AREA_SELECT_EXTEND_TYPE = {
  common: 'common',
};

export const HEAT_MAP_EXTEND_TYPE = {
  common: 'common',
};

export const SHOW_TOP_COUNTRIES_EXTEND_TYPE = {
  common: 'common',
};

export const ICONABLE_CHECKBOX_SELECT_EXTEND_TYPE = {
  common: 'common',
};

// 新风格情报-根据时间粒度，自定义时间左侧快捷菜单,粒度类型参数必传type
export const setShortcutOptionFun = (
  type: string,
  // startOfTimeValue = '',
  sinceReleaseTime = '',
  earliestDataTime = '',
): ShortcutOptionType => {
  const sinceReleaseTimeWeek = moment(sinceReleaseTime)
    .startOf('week')
    .format('YYYY-MM-DD');
  const sinceReleaseTimeMonth = `${moment(sinceReleaseTime).format(
    'YYYY-MM',
  )}-01`;

  // const allOfTimeObj = {
  //   name: 'All of time',
  //   nameCN: '所有时间',
  // };

  const sinceRelease = {
    name: 'Since Release',
    nameCN: '自发布以来',
    onClick: () => [moment(sinceReleaseTime), moment()],
  };

  const firstYearSinceReleaseByMonth = {
    name: 'First Year Since Release',
    nameCN: '发布后首年',
    onClick: () => [
      moment(sinceReleaseTimeMonth),
      moment(sinceReleaseTimeMonth).add(11, 'month').startOf('month'),
    ],
  };

  const firstWeekSinceReleaseByDate = {
    name: 'First Week Since Release',
    nameCN: '发布后首周',
    onClick: () => [moment(sinceReleaseTime), moment(sinceReleaseTime).add(6, 'days')],
  };

  const firstMonthSinceReleaseByDate = {
    name: 'First Month Since Release',
    nameCN: '发布后首月',
    onClick: () => [
      moment(sinceReleaseTime),
      moment(sinceReleaseTime).add(29, 'days'),
    ],
  };

  const firstYearSinceReleaseByDate = {
    name: 'First Year Since Release',
    nameCN: '发布后首年',
    onClick: () => [
      moment(sinceReleaseTime),
      moment(sinceReleaseTime).add(364, 'days'),
    ],
  };

  const sinceReleaseByWeek = {
    name: 'Since Release',
    nameCN: '自发布以来',
    onClick: () => [
      moment(sinceReleaseTime).startOf('week').format('YYYY-MM-DD'),
      moment().endOf('week'),
    ],
  };

  const firstYearSinceReleaseByWeek = {
    name: 'First Year Since Release',
    nameCN: '发布后首年',
    onClick: () => [
      moment(sinceReleaseTimeWeek),
      moment(sinceReleaseTime).add(364, 'days'),
    ],
  };

  const earliestData = {
    name: 'Earliest Data',
    nameCN: '最早数据',
    onClick: () => [moment(earliestDataTime), moment()],
  };

  // const allDateOfTime = {
  //   ...allOfTimeObj,
  //   onClick: () => [moment(startOfTimeValue), moment()],
  // };
  // const allWeekOfTime = {
  //   ...allOfTimeObj,
  //   onClick: () => [moment(startOfTimeValue).startOf('week'), moment().weekday(6)],
  // };
  // const allMonthOfTime = {
  //   ...allOfTimeObj,
  //   onClick: () => [moment(startOfTimeValue), moment().endOf('month')],
  // };

  let dateArray = [
    {
      name: 'Last 7 Days',
      nameCN: '最近7天',
      onClick: () => [moment().subtract(7, 'day'), moment().subtract(1, 'day')],
    },
    {
      name: 'Last 30 Days',
      nameCN: '最近30天',
      onClick: () => [
        moment().subtract(30, 'day'),
        moment().subtract(1, 'day'),
      ],
    },
    {
      name: 'Last 90 Days',
      nameCN: '最近90天',
      onClick: () => [
        moment().subtract(90, 'day'),
        moment().subtract(1, 'day'),
      ],
    },
    {
      name: 'Last 180 Days',
      nameCN: '最近180天',
      onClick: () => [
        moment().subtract(180, 'day'),
        moment().subtract(1, 'day'),
      ],
    },
    {
      name: 'Last 365 Days',
      nameCN: '最近365天',
      onClick: () => [
        moment().subtract(365, 'day'),
        moment().subtract(1, 'day'),
      ],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => [moment().startOf('year'), moment()],
    },
  ];

  let weekArray = [
    {
      name: 'Last 4 Weeks',
      nameCN: '最近4周',
      onClick: () => [moment().weekday(-7 * 4), moment().weekday(-1)],
    },
    {
      name: 'Last 12 Weeks',
      nameCN: '最近12周',
      onClick: () => [moment().weekday(-7 * 12), moment().weekday(-1)],
    },
    {
      name: 'Last 26 Weeks',
      nameCN: '最近26周',
      onClick: () => [moment().weekday(-7 * 26), moment().weekday(-1)],
    },
    {
      name: 'Last 52 Weeks',
      nameCN: '最近52周',
      onClick: () => [moment().weekday(-7 * 52), moment().weekday(-1)],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () =>
        // 取末尾为本周日，如果语言环境修改了每周的起始时间（moment.locale(）），则需重新修改
        [moment().startOf('year').startOf('week'), moment().weekday(6)],
    },
  ];

  let monthArray = [
    {
      name: 'Last 3 Months',
      nameCN: '最近3个月',
      onClick: () => [
        moment().subtract(3, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 6 Months',
      nameCN: '最近6个月',
      onClick: () => [
        moment().subtract(6, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 12 Months',
      nameCN: '最近12个月',
      onClick: () => [
        moment().subtract(12, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Last 24 Months',
      nameCN: '最近24个月',
      onClick: () => [
        moment().subtract(24, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month'),
      ],
    },
    {
      name: 'Year to Date',
      nameCN: '今年',
      onClick: () => [moment().startOf('year'), moment().endOf('month')],
    },
  ];

  if (sinceReleaseTime !== '') {
    dateArray = [...dateArray, sinceRelease];
    weekArray = [...weekArray, sinceReleaseByWeek];
    monthArray = [...monthArray, sinceRelease];

    if (type === 'month') {
      dateArray = [...dateArray];
      weekArray = [...weekArray];
      monthArray = [...monthArray, firstYearSinceReleaseByMonth];
    }
    if (type === 'date') {
      dateArray = [
        ...dateArray,
        firstWeekSinceReleaseByDate,
        firstMonthSinceReleaseByDate,
        firstYearSinceReleaseByDate,
      ];
      weekArray = [...weekArray];
      monthArray = [...monthArray];
    }
    if (type === 'week') {
      dateArray = [...dateArray];
      weekArray = [...weekArray, firstYearSinceReleaseByWeek];
      monthArray = [...monthArray];
    }
  }

  if (earliestDataTime !== '') {
    dateArray = [...dateArray, earliestData];
    weekArray = [...weekArray, earliestData];
    monthArray = [...monthArray, earliestData];
  }
  // if (startOfTimeValue != '' && earliestDataTime == '') {
  //   dateArray = [...dateArray, allDateOfTime];
  //   weekArray = [...weekArray, allWeekOfTime];
  //   monthArray = [...monthArray, allMonthOfTime];
  // }

  return {
    date: dateArray,
    week: weekArray,
    month: monthArray,
  };
};

export const OPT_MAP = {
  '>': '>',
  '<': '<',
  '>=': '≥',
  '<=': '≤',
  '=': '=',
};
